import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { builds } from '../data/content';
import Reveal from './Reveal';
import SectionLabel from './SectionLabel';

const { FiArrowUpRight } = FiIcons;

function BuildCard({ build }) {
  return (
    <article className="build-card">
      <span className="badge">Active build, 2026</span>
      <h3>{build.title}</h3>
      <p>{build.body}</p>
      <div className="build-stat">{build.stat}</div>
      <a href={build.url} target="_blank" rel="noreferrer">
        {build.label}
        <SafeIcon icon={FiArrowUpRight} />
      </a>
    </article>
  );
}

function Builds() {
  return (
    <section className="indexed-section builds-section" id="builds">
      <SectionLabel number="02" label="BUILDS" />
      <div className="section-content">
        <Reveal className="section-heading">
          <p className="eyebrow">Working notes</p>
          <h2>What I&apos;m building right now</h2>
          <p>No agency behind either of these. Just a directory that started showing up in AI answers, and a mailer built to split a cost no single small business wanted to carry alone.</p>
        </Reveal>
        <div className="build-grid">
          {builds.map((build, index) => (
            <Reveal key={build.title} delay={index * 0.1}>
              <BuildCard build={build} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Builds;